import React, { useContext } from 'react';
import { RegionType } from './RegionType.enum';
import { BasePanel } from './BasePanel.component';
import { LayoutContext } from './LayoutContext';

export const TopPanel = props => {
	const context = useContext(LayoutContext);
	const { children, region } = props;
	const { deviceType, getLayout } = context;

	const regionLayout = getLayout(region) || {};
	const { isHidden = false } = regionLayout;

	if (isHidden) {
		return null;
	}

	return (
		<BasePanel className={`common-layout top-panel ${deviceType}`} region={RegionType.North}>
			{children}
		</BasePanel>
	);
};
